import { PasswordValidation } from './password-conditions';

/**
 * Validates a password against common requirements
 * @param password - The password to validate
 * @param confirmPassword - The confirm password to match against (optional)
 * @returns PasswordValidation object with validation results
 */
export const validatePassword = (
  password: string,
  confirmPassword?: string
): PasswordValidation => {
  const lengthValid = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_{|}~]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const passwordsMatch = confirmPassword !== undefined ? password === confirmPassword : true;

  return {
    lengthValid,
    hasNumber,
    hasSpecialChar,
    hasUpperCase,
    hasLowerCase,
    passwordsMatch,
  };
};

/**
 * Checks if a password meets all validation requirements
 * @param password - The password to validate
 * @param confirmPassword - The confirm password to match against (optional)
 * @returns boolean indicating if password is valid
 */
export const isPasswordValid = (
  password: string,
  confirmPassword?: string
): boolean => {
  const validation = validatePassword(password, confirmPassword);
  return validation.lengthValid &&
    validation.hasNumber &&
    validation.hasSpecialChar &&
    validation.hasUpperCase &&
    validation.hasLowerCase &&
    validation.passwordsMatch;
};

/**
 * Checks if passwords match
 * @param password - The password
 * @param confirmPassword - The confirm password
 * @returns boolean indicating if passwords match
 */
export const doPasswordsMatch = (
  password: string,
  confirmPassword: string
): boolean => {
  return password === confirmPassword;
}; 